// Grid
import { Grid } from "@mui/material";

// Components
import EmptyBody from "@Layouts/components/Basics/EmptyBody";
import TableLoader from "@Layouts/components/Skeletons/TableLoader";
import AdvisorPerformanceTable from "@DataPages/components/ServiceOperations/Tabs/AdvisorPerformance/Tables/AdvisorPerformanceTable";

// Assets
import emptyTable from "@/assets/images/commons/empty_table.png";

// Types
import { IAdvisorPerformance } from "@/DataPages/types/advisorPerformance/model";

interface IAdvisorPerformanceModelTableProps {
	data: IAdvisorPerformance[] | null;
	isLoading: boolean;
	isUpdatable?: boolean;
	hasNextPage: boolean;
}

export const AdvisorPerformanceModelTable = (props: Readonly<IAdvisorPerformanceModelTableProps>) => {
	const { data, isLoading, hasNextPage } = props;

	if (isLoading) {
		return (
			<Grid item xs={12} mt={1}>
				<TableLoader toolbar buttons={3} content rows={5} multiTitles={5} />
			</Grid>
		);
	}

	return (
		<Grid container alignContent="flex-start" className="h-full">
			<Grid container item>
				<Grid item xs={12} height={500} className="mt-4">
					{!data?.length ? (
						<EmptyBody
							image={emptyTable}
							title={"No Advisor Performance to show"}
							bodyHeightClassName={"!h-[435px]"}
							className="!shadow-none"
						/>
					) : (
						<AdvisorPerformanceTable loading={isLoading} data={data} hasNextPage={hasNextPage} />
					)}
				</Grid>
			</Grid>
		</Grid>
	);
};
